import { render } from "./EditDocumentView.vue?vue&type=template&id=4846cbdc"
import script from "./EditDocumentView.vue?vue&type=script&lang=js"
export * from "./EditDocumentView.vue?vue&type=script&lang=js"

import "./EditDocumentView.vue?vue&type=style&index=0&id=4846cbdc&lang=scss"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__